import { datadogRum } from '@datadog/browser-rum';
import rcclUUID from '@rcg/uuid';
import { ProviderConfig } from 'launchdarkly-react-client-sdk';
import { ILocale } from 'types';
import { rumLogger } from '../../rum/rumLogger';

const DEFAULT_USER_KEY = 'anonymous-user';

export function getLDProviderConfig(clientSideId: string, brandCode: string, envColor: string, locale: ILocale): ProviderConfig {
	let userKey = DEFAULT_USER_KEY;

	if (typeof window !== 'undefined') {
		userKey = rcclUUID.getRWDId();

		if (!userKey) {
			rumLogger.error('Error initializing LaunchDarkly user context', {
				source: 'getLDProviderConfig',
				err: `Missing RDW_ID: Got ${userKey}`,
			});
		}
	}

	return {
		clientSideID: clientSideId,
		context: {
			kind: 'user',
			key: userKey ?? DEFAULT_USER_KEY,
			activeColor: envColor,
			application: 'cruise-search-client',
			brand: brandCode,
			countryCode: locale?.country,
			currency: locale?.currency,
			lang: locale?.language,
			market: locale?.market,
			userId: userKey, // deprecated
		},
		options: {
			inspectors: [
				{
					type: 'flag-used',
					name: 'dd-inspector',
					method: (key, details) => {
						datadogRum.addFeatureFlagEvaluation(key, details.value);
					},
				},
			],
		},
	};
}
